module.exports = __webpack_public_path__ + "static/media/icon_file_error.2092e256.svg";